import { useState } from "react";
import { aiFAQData } from "@/mocks/aiSolutionsData";
import AnimatedSection from "@/components/AnimatedSection";

export default function AiFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="container-astro">
        <AnimatedSection>
          <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-3 font-heading tracking-tight">
              {aiFAQData.heading}
            </h2>
            <div className="w-16 h-1 rounded-full mx-auto bg-gradient-to-r from-[#2563EB] via-[#7C3AED] to-[#F97316]" />
          </div>
        </AnimatedSection>

        <div className="max-w-3xl mx-auto flex flex-col gap-3 md:gap-4">
          {aiFAQData.items.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <AnimatedSection key={item.q} delay={i * 60}>
                <div
                  className={`rounded-2xl border transition-all duration-300 ${
                    isOpen
                      ? "border-accent-200 bg-background-50 shadow-sm"
                      : "border-background-200/80 bg-background-50 hover:border-background-300"
                  }`}
                >
                  <button
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
                    aria-expanded={isOpen}
                  >
                    <span className="text-sm md:text-base font-semibold text-foreground-950 font-heading">
                      {item.q}
                    </span>
                    <span
                      className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center transition-all duration-300 ${
                        isOpen
                          ? "bg-gradient-to-r from-[#2563EB] to-[#7C3AED] text-white rotate-180"
                          : "bg-background-100 text-foreground-500"
                      }`}
                    >
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-arrow-down-s-line" />
                      </span>
                    </span>
                  </button>
                  <div
                    className={`faq-content ${isOpen ? "open" : ""}`}
                    style={{ padding: isOpen ? "0 1.5rem 1.5rem" : "0 1.5rem" }}
                  >
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </AnimatedSection>
            );
          })}
        </div>
      </div>
    </section>
  );
}